import { Component, Input, OnInit } from '@angular/core';
import { Cms } from '@impact/data';

@Component({
    selector: 'app-product-grid-spot',
    template: `
        <ng-container *ngIf="data" [ngSwitch]="data.spotLink !== undefined">
            <ng-container *ngSwitchCase="true">
                <ng-container [ngSwitch]="useRouter">
                    <a
                        *ngSwitchCase="true"
                        [routerLink]="data.spotLink.cleanUrl"
                        [queryParams]="data.spotLink.urlParams"
                        class="product-grid-spot"
                    >
                        <ng-container *ngTemplateOutlet="spotContent; context: { content: data }"></ng-container>
                    </a>
                    <a *ngSwitchCase="false" [href]="data.spotLink.cleanUrl" class="product-grid-spot" appInterceptLinks>
                        <ng-container *ngTemplateOutlet="spotContent; context: { content: data }"></ng-container>
                    </a>
                </ng-container>
            </ng-container>
            <div class="product-grid-spot" *ngSwitchCase="false">
                <ng-container *ngTemplateOutlet="spotContent; context: { content: data }"></ng-container>
            </div>
        </ng-container>

        <ng-template #spotContent let-content>
            <ng-container *ngIf="data.imageAsBackground; else imageHolder">
                <ng-container *ngTemplateOutlet="imageAsBackground; context: { content: data }"></ng-container>
            </ng-container>
        </ng-template>

        <ng-template #imageAsBackground let-content>
            <div  [ngClass]="{'product-grid-spot__fill': data.imageAsBackground}">
                <div class="rich-text" [ngClass]="{'add-overlay': data.addImageOverlay}"  [innerHTML]="data.spotText | safe: 'html'" appInterceptLinks></div>
                <img class="product-grid-spot__image-as-bg" [alt]="data.spotImage.alt || ''" [src]="data.spotImage.src | resolveMediaUrl: { format: 'webp' }" />
            </div>
        </ng-template>

        <ng-template #imageHolder let-content>
            <!-- If there is no spotImage, nothing will be rendered and we will get an space -->
            <ng-container *ngIf="data.spotImage">
                <img class="product-grid-spot__image" [alt]="data.spotImage.alt || ''" [src]="data.spotImage.src | resolveMediaUrl: { format: 'webp' }" />
                <div class="rich-text" [innerHTML]="data.spotText | safe: 'html'" appInterceptLinks></div>
            </ng-container>
        </ng-template>
    `,
})
export class ProductGridSpotComponent implements OnInit {
    @Input() data: Cms.ProductGridSpot;
    useRouter = false;

    ngOnInit() {
        if (this.data.spotLink) {
            if (this.data?.spotLink?.urlParams) {
                this.useRouter = true;
            }
        }
    }
}
